import pageDefaultMixin from "@/mixins/page/pageDefaultMixin";
import pageListMixin from "@/mixins/page/pageListMixin";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service"


export default {
    mixins: [pageDefaultMixin, pageListMixin],
    data() {
        return {
            id: "",
            onSending: false,
            filtered: false,
            enableAllFilters: false,
        }
    },
    async mounted() {

        this.searchParams.append('pageSize', "10")

    },
    methods: {

        closeSearch() {
            this.$emit("onClose")
        },

        selectItemList(id) {

            if (id > 0) {
                this.$bvModal.hide(this.id)
                this.$emit("onSelected", id)
            }

        },

        async executeAfterSearch(){

        },

        async executeSearchInput() {

            this.pageListIsLoaded = false

            await this.executeSearch(false, false)

            await this.executeAfterSearch() //terá override na página que estiver utilizando


        },

        async getPageSearchList(pageNumber, finishLoaded = true) {

            this.pageListIsLoaded = false

            //DEVERÁ MONTAR OS PARÂMETROS DINAMICAMENTE CONFORME OS CAMPOS FOREM MARCADOS COMO DE PESQUISA
            await crudGeneral.getAll(this.path, pageNumber, this.searchParams)
                .then(response => {

                    this.request = response.data

                    if (finishLoaded)
                        this.pageListIsLoaded = true

                })
                .catch(error => {
                    console.log('Erro externo: ' + error)
                })

        },

    },
    props: {
        show: Boolean,
        codeLabel: String,
    },
    watch: {

        show(v) {
            if (v) {
                this.executeSearchInput()
            }
        },
        codeLabel(v) {
            this.form.default = v
        },

    },

}


